import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

import { ContentStatus } from "./knowledgeDb";

const { REQUIRED } = ERROR_TYPE;

export enum ProductType {
	PRODUCT = "PRODUCT",
	SERVICE = "SERVICE",
	FRAMEWORK = "FRAMEWORK",
}

export const PRODUCT_TYPE_LABELS: Record<ProductType, string> = {
	[ProductType.PRODUCT]: "Product",
	[ProductType.SERVICE]: "Service",
	[ProductType.FRAMEWORK]: "Framework",
};

export interface TargetSegment {
	id: number;
	scoreCompanyCategoryId: number;
	name: string;
	isActive: boolean;
}

export interface Product {
	id: number;
	name: string;
	type: ProductType;
	description: string;
	keyFeatures: string[];
	targetSegments: TargetSegment[];
	competitiveDiff: string;
	pricing: string;
	status: ContentStatus;
	companyId: number;
	createdAt: string;
	updatedAt: string;
}

export const CreateProductSchema = z.object({
	name: z.string().min(1, { message: REQUIRED }).trim(),
	type: z.nativeEnum(ProductType),
	description: z.string().min(1, { message: REQUIRED }).trim(),
});

export type CreateProduct = z.infer<typeof CreateProductSchema>;
